import { notification } from "antd";
import moment from "moment";

import history from "../../routes/history";
import api from "../api";
import ApiException from "../exception/ApiException";
import { getPaciente } from "../pacientes";
import { getEntities } from "../entity";

const ERROR = "Não foi possível atualizar a solicitação";

const normalizeSolicitacao = (values) => {
  values.clinica_id = JSON.parse(values.clinica).id;
  values.paciente_id = JSON.parse(values.paciente).id;
  values.profissional_id = JSON.parse(values.profissional).id;
  values.profissional_clinica_id = JSON.parse(values.profissional_clinica).id;
  values.unidade_id = JSON.parse(values.unidade).id;
  values.data = moment(values.data).format("Y-M-D HH:mm");
  delete values.paciente;
  delete values.clinica;
  delete values.profissional;
  delete values.profissional_clinica;
  delete values.unidade;
  delete values.created_by;
  delete values.updated_by;
  delete values.marcador;
};

const onGetSolicitacao = (values) => {
  values.clinica = JSON.stringify(values.clinica);
  values.paciente = JSON.stringify(values.paciente);
  values.profissional = JSON.stringify(values.profissional);
  values.profissional_clinica = JSON.stringify(values.profissional_clinica);
  values.unidade = JSON.stringify(values.unidade);
  values.data = moment(values.data, "Y-M-D HH:mm");
};

const registerSolicitacao = async (values) => {
  try {
    normalizeSolicitacao(values);
    const { data } = await api.post("solicitacoes", values);
    history.push("/solicitacoes");
    notification.open({
      message: "Solicitação adicionada com sucesso!",
    });
    return data;
  } catch (error) {
    throw new ApiException(error?.response?.data?.error || ERROR);
  }
};

const deleteSolicitacao = async (id) => {
  try {
    await api.delete(`solicitacoes/${id}`);
    notification.open({
      message: "Solicitação deletada com sucesso",
    });
  } catch (error) {
    notification.open({
      message: error?.response?.data?.error,
    });
  }
};

const getSolicitacoes = async (page, filter = "") => {
  const { data: solicitacaos } = await api.get(
    `solicitacoes?page=${page}&filter=${filter}`
  );
  return solicitacaos;
};

const getSolicitacoesByPaciente = async (pacienteId, page) => {
  const { data: solicitacaos } = await api.get(
    `solicitacoes?page=${page}&paciente_id=${pacienteId}`
  );
  return solicitacaos;
};

const getSolicitacoesByProfissional = async (profissionalId, page) => {
  const { data: solicitacaos } = await api.get(
    `solicitacoes?page=${page}&profissional_id=${profissionalId}`
  );
  return solicitacaos;
};
const getSolicitacoesByClinica = async (clinicaId, page) => {
  const { data: solicitacaos } = await api.get(
    `solicitacoes?page=${page}&clinica_id=${clinicaId}`
  );
  return solicitacaos;
};

const getSolicitacao = async (id) => {
  try {
    const { data } = await api.get(`solicitacoes/${id}`);
    onGetSolicitacao(data);
    return data;
  } catch (error) {
    throw new ApiException(error?.response?.data?.error || ERROR);
  }
};

const abrirComprovanteSolicitacao = async (id) => {
  const url = `${process.env.REACT_APP_API_URL}/solicitacoes/comprovante/${id}`;
  window.open(url, "PRINT", "height=720,width=900");
};

const getByCurrentMonthAndPaciente = async (id, procedimentoId) => {
  try {
    const { data } = await api.get(
      `solicitacoes/paciente/${id}/${procedimentoId}`
    );
    data.forEach((solicitaao) => onGetSolicitacao(solicitaao));
    return data;
  } catch (error) {
    throw new ApiException(error?.response?.data?.error || ERROR);
  }
};

const getByCurrentMonthRetroAndPaciente = async (id, procedimentoId) => {
  try {
    const { data } = await api.get(
      `solicitacoes/paciente/procedimentosretroativos/${id}/${procedimentoId}`
    );
    data.forEach((solicitaao) => onGetSolicitacao(solicitaao));
    return data;
  } catch (error) {
    throw new ApiException(error?.response?.data?.error);
  }
};

const updateSolicitacao = async (solicitacao, values) => {
  try {
    normalizeSolicitacao(values);
    values.id = solicitacao.id;
    await api.put("solicitacoes", values);
    history.push("/solicitacoes");
    notification.open({
      message: "Solicitacão atualizada com sucesso!",
    });
  } catch (error) {
    throw new ApiException(error?.response?.data?.error || ERROR);
  }
};
const sendMessageAprovado = async (solicitacao) => {
  // const newSolicitacao = JSON.parse(solicitacao);
  // console.log(newSolicitacao);
  try {
    const entidade = await getEntities();
    const cidade = entidade.pessoa_juridica.endereco.cidade;
    const paciente = JSON.parse(solicitacao.paciente)//await getPaciente(solicitacao.paciente_id);
    const clinica = JSON.parse(solicitacao.clinica)
    const profissional = JSON.parse(solicitacao?.profissional);
    const data = moment(solicitacao.data).format("DD/MM/YYYY");
    const hora = moment(solicitacao.data).format("HH:mm");
    const messageProfissional = profissional !== null && profissional != undefined ? `com o profissional *${profissional.pessoa_fisica.nome}*` : "";
    const message = `Olá Sr(a). *${paciente.pessoa_fisica.nome}*, a secretaria de saúde de ${cidade} informa que seu agendamento para a consulta em *${clinica.pessoa_juridica.nome}* foi *APROVADA* e marcada para o dia: *${data}* às *${hora}hs*.`
    const response = await api.post("/whatsapp", {
      number: paciente.pessoa_fisica.celular,
      message: message,
    });

    if (response.status === 201) {
      notification.success({
        message: "Mensagem enviada e criada com sucesso!",
      });
    } else if (response.status === 200) {
      notification.success({
        message: "Mensagem enviada com sucesso!",
      });
    }

    history.push("/solicitacoes");
  } catch (error) {
    const status = error?.response?.status;

    if (status === 400) {
      notification.warning({
        message: "Número de WhatsApp inválido ou dados incompletos.",
      });
    } else if (status === 500) {
      notification.error({
        message: "Erro interno no servidor ao enviar mensagem.",
      });
    } else {
      notification.error({
        message: "Erro inesperado ao enviar mensagem para o WhatsApp.",
      });
    }

    throw new ApiException(error?.response?.data?.error || ERROR);
  }
};
const naoRealizarSolicitacao = async (id, observacaoClinica) => {
  try {
    await api.patch("solicitacoes/nao-realizar/" + id, { observacaoClinica });
    notification.open({
      message: "Solicitacão atualizada com sucesso!",
    });
  } catch (error) {
    console.log(error);
    throw new ApiException(error?.response?.data?.error || ERROR);
  }
};

const realizarSolicitacao = async (id) => {
  try {
    await api.patch("solicitacoes/realizar/" + id);
    notification.open({
      message: "Solicitacão atualizada com sucesso!",
    });
  } catch (error) {
    console.log(error);
    throw new ApiException(error?.response?.data?.error || ERROR);
  }
};

export {
  abrirComprovanteSolicitacao,
  deleteSolicitacao,
  getByCurrentMonthAndPaciente,
  getByCurrentMonthRetroAndPaciente,
  getSolicitacao,
  getSolicitacoes,
  getSolicitacoesByClinica,
  getSolicitacoesByPaciente,
  getSolicitacoesByProfissional,
  naoRealizarSolicitacao,
  realizarSolicitacao,
  registerSolicitacao,
  sendMessageAprovado,
  updateSolicitacao,
};
